import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6 mb-3" }
const _hoisted_4 = { class: "midTitle mb-3 text-center" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "midTitle mb-3 text-center" }
const _hoisted_8 = { class: "box" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_comments_container = _resolveComponent("comments-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_localized_text, {
            localizedKey: "Commenti amministrazione",
            text: "Commenti amministrazione"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_comments_container, {
            comments: _ctx.comments,
            onAdd: _ctx.addCallback
          }, null, 8, ["comments", "onAdd"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_localized_text, {
            localizedKey: "Allegati lato utente",
            text: "Allegati lato utente"
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_comments_container, {
            comments: _ctx.attachments,
            modify: false
          }, null, 8, ["comments"])
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Chiudi",
          text: "Chiudi"
        })
      ])
    ])
  ]))
}